// Internal linking system — automatic bidirectional links between
// blog posts, guides, and city pages via keyword matching.
// New WordPress posts get city links (and vice versa) with zero manual edits.

import { CITIES } from "./cities";
import { GUIDES, GUIDE_ORDER } from "./guides";

// Topic keywords that connect a piece of text to a city page
const CITY_KEYWORDS = {
  "bail-lawyer-delhi": ["delhi", "tis hazari", "patiala house", "saket", "rohini", "karkardooma", "dwarka"],
  "bail-lawyer-allahabad": ["allahabad", "prayagraj"],
  "bail-lawyer-lucknow": ["lucknow"],
  "bail-lawyer-patna": ["patna", "bihar"],
  "bail-lawyer-bangalore": ["bengaluru", "bangalore", "karnataka"],
  "bail-lawyer-kolkata": ["kolkata", "calcutta", "west bengal"],
  "bail-lawyer-guwahati": ["guwahati", "gauhati", "assam"],
  "bail-lawyer-mumbai": ["mumbai", "bombay", "andheri", "borivali", "esplanade", "dindoshi"],
  "bail-lawyer-chennai": ["chennai", "madras", "tamil nadu", "egmore", "saidapet"],
  "bail-lawyer-hyderabad": ["hyderabad", "telangana", "secunderabad", "cyberabad", "nampally"],
  "bail-lawyer-jaipur": ["jaipur", "jodhpur", "rajasthan"],
  "bail-lawyer-ahmedabad": ["ahmedabad", "gujarat", "gandhinagar", "sola"],
  "bail-lawyer-bhopal": ["bhopal", "madhya pradesh", "jabalpur", "indore", "gwalior"],
  "bail-lawyer-chandigarh": ["chandigarh", "punjab", "haryana", "panchkula", "mohali"],
};

// Topic keywords that connect a piece of text to a guide
const GUIDE_KEYWORDS = {
  "what-it-costs": ["fee", "fees", "cost", "charge", "bribe", "money", "payment", "लागत", "फ़ीस", "फीस", "रिश्वत"],
  timeline: ["how long", "timeline", "days", "delay", "कितना समय"],
  "legal-terms": ["meaning", "term", "glossary", "chargesheet", "remand", "मतलब", "शब्द"],
  "bail-process": ["bail", "anticipatory", "bnss", "crpc", "arrest", "fir", "ज़मानत", "जमानत", "गिरफ़्तारी"],
};

const clean = (s) => (s || "").toLowerCase().replace(/<[^>]*>/g, " ");

// Cities mentioned in a text (post title / excerpt / content)
export function matchCitiesInText(text) {
  const t = clean(text);
  if (!t.trim()) return [];
  return Object.entries(CITY_KEYWORDS)
    .filter(([, kws]) => kws.some((k) => t.includes(k)))
    .map(([slug]) => CITIES[slug])
    .filter(Boolean);
}

// Guides relevant to a text, best match first; always returns all guides
export function matchGuidesInText(text) {
  const t = clean(text);
  const scored = Object.entries(GUIDE_KEYWORDS)
    .map(([slug, kws]) => ({ slug, score: kws.filter((k) => t.includes(k)).length }))
    .sort((a, b) => b.score - a.score)
    .map((x) => x.slug);
  GUIDE_ORDER.forEach((s) => {
    if (!scored.includes(s)) scored.push(s);
  });
  return scored.map((s) => GUIDES[s]).filter(Boolean);
}

// Does a blog post relate to a specific city page?
export function postMatchesCity(post, slug) {
  const kws = CITY_KEYWORDS[slug] || [];
  const t = clean(`${post.title || ""} ${post.excerpt || ""} ${post.content || ""}`);
  return kws.some((k) => t.includes(k));
}

export const ALL_CITIES = Object.values(CITIES);
export const ALL_GUIDES = GUIDE_ORDER.map((s) => GUIDES[s]);
